<app-entity-history [isDynamicEntity]="true"></app-entity-history>